import React from 'react';
import styled from 'styled-components';

const FADED = 'var(--vo-steel)';
const TEXT = 'var(--vo-ink-2)';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
`;
const ReqCode = styled.span`
  font-family: 'Maven Pro', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: ${FADED};
  flex-shrink: 0;
`;
const ReqTitle = styled.span`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: ${TEXT};
  line-height: 1.5;
`;

const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// ~95% of ga_frameworks_reqs titles already embed the code as a literal prefix
// (e.g. "A1.1 - Capacity & Performance Management"); the remaining ~5% don't
// (e.g. "4.1" -> "Understanding the organization and its context"). Strip a
// leading code + separator so the majority case doesn't visibly duplicate the code.
const stripCodePrefix = (title, code) => {
  if (!title) return '';
  const trimmedTitle = String(title).trim();
  if (!code) return trimmedTitle;

  const escapedCode = escapeRegExp(String(code).trim());
  const prefixPattern = new RegExp(`^${escapedCode}\\s*(?:-|\\.|:)\\s*`, 'i');
  return trimmedTitle.replace(prefixPattern, '').trim();
};

const RequirementLabel = ({ code, title }) => {
  const cleaned = stripCodePrefix(title, code);
  return (
    <Wrapper>
      <ReqCode>{code}</ReqCode>
      {cleaned && <ReqTitle>{cleaned}</ReqTitle>}
    </Wrapper>
  );
};

export default RequirementLabel;
